const MAX_NOTIFICATION_PERCENT = 100;

export const activeToMaxPercentageRatio = (active, max) => {
  const exactPercent = Math.abs(Math.floor((active / max) * 100));
  const decimalPercent = exactPercent <= MAX_NOTIFICATION_PERCENT ? Math.floor(exactPercent / 10) * 10 : MAX_NOTIFICATION_PERCENT;

  return {
    exactPercent,
    decimalPercent,
  };
};
